import { getEnvironmentApiUrls } from '@dvag/dfs-constant-config';
import {
  FamilyApprovalType,
  MultipleFamilyApprovalType,
  MultipleHouseHoldType,
  PersonMultipleHouseHoldData,
} from 'type/twoFactor';
import { getApiClient } from './api-client';

export const consultationFamilyApprovalApi = () => {
  const baseURL = `${getEnvironmentApiUrls().consultationService}`;
  const api = getApiClient(baseURL);

  const sendMultipleFamilyApproval = async (
    payload: MultipleFamilyApprovalType,
    signal?: AbortSignal,
  ) =>
    api.post<FamilyApprovalType>(
      `/family-approval/household/${payload.householdId}/client/${payload.customerPersonId}/multiple-approval`,
      { data: payload.data },
      { signal },
    );

  const getMultipleHouseholdPerPerson = async (payload: MultipleHouseHoldType) =>
    api.get<PersonMultipleHouseHoldData[]>(
      `/family-approval/household/${payload.householdId}/client/${payload.customerPersonId}/multiple-households`,
    );

  const sendFamilyApproval = async (payload: FamilyApprovalType, signal?: AbortSignal) =>
    api.post<FamilyApprovalType>(
      `/family-approval/${payload.householdId}/person/${payload.customerPersonId}/family-approval`,
      {
        approvalDuration: payload.duration.value,
      },
      { signal },
    );

  return {
    sendMultipleFamilyApproval,
    getMultipleHouseholdPerPerson,
    sendFamilyApproval,
  };
};
